import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const THIRDPARTYPROPERTYCATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('description', 'Entity.ThirdPartyPropertyCategory.Description')
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ThirdPartyPropertyCategory.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
];

export const THIRDPARTYPROPERTYCATEGORY_CONFIG = {
  entityName: 'ThirdPartyPropertyCategory',
  localizationKey: 'Planning::Entity.ThirdPartyPropertyCategory',
  fields: THIRDPARTYPROPERTYCATEGORY_FIELDS,
  permission: 'ControllingContract.ThirdPartyPropertyCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
